import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { CherryDevTheme } from '../CherrySoftware/CherryDevTheme';
import { Hero, Structure, Investment, Payment, NextSteps } from './components';
import { FARMA, PAGE_TITLE, PAGE_DESCRIPTION } from './farmaferContent';

const FONT_ID = 'farmafer-fonts';
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;500;600;700&family=Syne:wght@600;700;800&display=swap';

const LandingFarmaferInner = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', PAGE_DESCRIPTION);

    if (!document.getElementById(FONT_ID)) {
      const link = document.createElement('link');
      link.id = FONT_ID;
      link.rel = 'stylesheet';
      link.href = FONT_HREF;
      document.head.appendChild(link);
    }
  }, []);

  return (
    <Box
      sx={{
        bgcolor: FARMA.mist,
        color: FARMA.ink,
        fontFamily: '"Source Sans 3", "Outfit", sans-serif',
        minHeight: '100vh',
      }}
    >
      <Hero />
      <Structure />
      <Investment />
      <Payment />
      <NextSteps />
    </Box>
  );
};

const LandingFarmafer = () => (
  <CherryDevTheme>
    <LandingFarmaferInner />
  </CherryDevTheme>
);

LandingFarmafer.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingFarmafer;
